import {handleLogout} from "components/utils"; import React, {createRef, useEffect, useRef, useState} from 'react';
import axios from "axios";
import {Accordion, Button, Card, Col, Modal, Nav, Row, Tab, Tabs} from "react-bootstrap";
import {ClientSelfView} from "./ClientSelfView";
import {ClientConfig} from "../ClientConfig";
import {validatePhoneNumber} from "../../utils";
import {Roles} from "../../permissions";

export const ClientSettingsView = (props: { cookieEntityQr: string, cookieQr: string }) => {

    const [isBasic, setIsBasic] = useState(false)
    const [users, setUsers] = useState([])
    const [name, setName] = useState(null)
    const [mobile, setMobile] = useState(null)
    const [error, setError] = useState(null)

    function loadEntityData() {
        axios.get('/api/backend/entity/profile/' + props.cookieEntityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setUsers(resp.data.users)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {
        // Perform localStorage action
        setIsBasic(!(localStorage.getItem('opd') == "true")
            && !(localStorage.getItem('ipd') == "true")
            && !(localStorage.getItem('inventory') == "true")
            && !(localStorage.getItem('radiology') == "true")
            && !(localStorage.getItem('lab') == "true"))
    }, [])

    useEffect(() => {
        // Perform localStorage action
        loadEntityData()
    }, [props.cookieEntityQr])

    const handleRemove = (user) => {
        setError(null)
        console.log("Deleting user")
        axios.post('/api/backend/user/remove', {
            mobile: user.mobile,
            qrCode: user.qrCode,
            role: user.role
        })
            .then(resp => {
                loadEntityData()
            })
            .catch(err => {
                setError("* Removing user failed. Please retry")
            });
    }

    const handleAddUser = () => {
        setError(null)
        if (!validatePhoneNumber(mobile)) {
            setError("* Please enter valid mobile number")
            return
        }
        const headers = {headers: {"Content-Type": "application/json"}};
        axios.post('/api/backend/entity/profile/' + props.cookieEntityQr + '/fd_exec/create', {
            mobile: mobile,
            entityQrCode: props.cookieEntityQr,
            name: name,
            permissions: Roles.FD_EXEC
        }, headers)
            .then(resp => {
                setName("")
                setMobile("")
                loadEntityData()
            })
            .catch(err => {
                setError("* Adding user failed. Please retry")
            });
    }

    function getUsers() {
        return <>
            <div className="text-primary fs-5">Front Desk Users</div>
            <table className="table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {users.map((user) => {
                    return <tr key={user}>
                        <td>{user.name}</td>
                        <td>{user.mobile}</td>
                        <td>
                            <button className="btn btn-sm btn-outline-warning bg-white"
                                    onClick={e => handleRemove(user)}>X
                            </button>
                        </td>
                    </tr>
                })}
                <tr>
                    <td><input type="text" value={name} onChange={e => setName(e.target.value)} className="form-control form-control-sm"
                               placeholder="Enter Name"/></td>
                    <td><input type="tel" value={mobile} onChange={e => setMobile(e.target.value)} className="form-control form-control-sm"
                               placeholder="Enter Mobile"/></td>
                    <td>
                        <button className="btn btn-sm btn-success text-white" onClick={handleAddUser}>+</button>
                    </td>
                </tr>
                </tbody>
            </table>
            {error &&
                <div className="my-3 text-danger fs-6">{error}</div>
            }
        </>
    }

    return (
        <>
            <Card>
                <div className="m-4">
                    {!isBasic && <ClientConfig cookieQr={props.cookieQr}/>}
                    {isBasic && getUsers()}
                </div>
            </Card>
        </>
    );
};

